export default __webpack_public_path__ + "static/media/warningIcon.ae4846c0.svg";